import { Quill } from 'react-quill'; // ES6
import Parchment from 'parchment';

const IdAttribute = new Parchment.Attributor.Attribute('id', 'id', {
    scope: Parchment.Scope.BLOCK,
});

Quill.register(
    {
        'attributors/attribute/id': IdAttribute,
    },
    true,
);

Quill.register(
    {
        'formats/id': IdAttribute,
    },
    true,
);

export default IdAttribute;



// WEBPACK FOOTER //
// ./src/components/complex/manage/template/IdAttribute.js